import { install } from './install';

const VueIntercom = {
  install,
};

export default VueIntercom;
